import { useEffect, useRef, useState } from "react";
import { _AccountINFORPO, _CreditProcessMovement, _LoanConfigProfile, _single } from "../../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../../../theme/Component/BasicPage"
import { CompanyEditor } from "../../../../../erp/cellEditor/Company/CompanyEditor";
import { CustomProcessTypeSeleect } from "../../../../../erp/cellEditor/CustomProcessType/CustomProcessTypeSeleect";
import { SelectTypeProcees } from "../../../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { BudgetAccountantOperationSelect } from "../../../../../erp/cellEditor/BudgetAccountantOperation/BudgetAccountantOperationSelect";
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { AccountEditor } from "../../../../../editor/AccountEditor";
import { InputMoney } from "../../../../../theme/Input/InputMoney";
import useModal, { MODAL_md, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { toast } from "react-toastify";
import { ComponentCreditosDisponiblesDescuentoNominaTercero } from "./ComponentCreditosDisponiblesDescuentoNominaTercero";
import { SelectPayrollFactor } from "./SelectPayrollFactor";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { Alert } from "../../../../../theme/Component/Alert";

interface ParamProps {
    IDAccount: number;
    Year: number;
    Month: number;
    Moves: any[];
}

export const PagoDescuentoNominaTercero = () => {

    const _credit = useDataBean(_CreditProcessMovement);
    const _config = useDataBean(_LoanConfigProfile);

    const [param, setParam] = useState<any>({
        IDCompany: 1,
        Year: _single.getCurrenYear(),
        Month: _single.getCurrentMonth(),
        Moves: [],
    });

    const [movement, setMovement] = useState<any>([]);
    const [employee, setEmployee] = useState<any>({});
    const [document, setDocument] = useState<any>({});
    const modalDocumento = useModal("Documento", MODAL_XL);

    const grabarCompensacion = () => {

        const requiredParams = [
            { key: "Year", value: param.Year },
            { key: "Month", value: param.Month },
            { key: "IDPayrollFactor", value: param.IDPayrollFactor },
            { key: "CustomProcessType", value: param.CustomProcessType },
            { key: "AccountantDate", value: param.AccountantDate },
            { key: "idBudgetAccountantOperation", value: param.idBudgetAccountantOperation },
            { key: "IDAccount", value: param.IDAccount },
            { key: "employee.Value", value: employee.Value }
        ];

        const missing = requiredParams.filter(p => p.value === null || p.value === undefined || p.value === "");
        if (missing.length > 0) {
            toast.error(`Faltan parámetros requeridos: ${missing.map(m => m.key).join(", ")}`);
            return;
        }

        console.log(
            param.Year,
            param.Month,
            param.IDPayrollFactor,
            param.CustomProcessType,
            param.AccountantDate,
            param.idBudgetAccountantOperation,
            param.IDAccount,
            param.Moves,
            employee.Value,
            _single.getAccountID()
        )

        _config.instance.parseQuotaCreditForEmployee(
            param.Year,
            param.Month,
            param.IDPayrollFactor,
            param.CustomProcessType,
            param.AccountantDate,
            param.idBudgetAccountantOperation,
            param.IDAccount,
            param.Moves,
            employee.Value,
            _single.getAccountID()
        ).then(
            (resp: any) => {
                console.log(resp);
                if (resp.ReportList) {
                    setDocument(resp.ReportList);
                    toast.success("Pago aplicado");
                    modalDocumento.open();
                } else {
                    toast.warning("Documento con novedades no se pudo aplicar");
                }
            }
        )

    }

    const getPayrollDeductionsForCreditQuota = () => {

        if (!param.IDAccount) {
            toast.warning("Debe seleccionar un tercero");
            return;
        }
        if (param.IDPayrollFactor == null) {
            toast.warning("Debe seleccionar un Payroll a Aplicar");
            return;
        }
        _credit.instance.getPayrollDeductionsForCreditQuota(param.Year, param.Month, param.IDAccount, param.IDPayrollFactor).then(
            (resp: any) => {
                if (resp.length > 0) {
                    credits.current?.setEmployee(resp[0]);
                    setEmployee(resp[0]);
                    setDocument([]);
                    credits.current?.openModal();
                }
                else {
                    toast.warning("No se encontraron descuentos para el mes seleccionado");
                    setEmployee({});
                }
            }
        )
    }

    const credits = useRef<any>(null);

    return (
        <BasicPage titulo="Aplicar Abonos de Cartera desde Descuentos de Nómina por Funcionario">
            <div className="row">
                <div className="col-md-2">
                    <YearSelector value={param.Year} onChange={(e) => { setParam({ ...param, "Year": e }) }} />
                </div>
                <div className="col-md-2">
                    <SelectMonths idSelector={param.Month} onChange={(e) => { setParam({ ...param, "Month": e }) }} />
                </div>
                <div className="col-md-4">
                    <CompanyEditor id={param.IDCompany} onchange={(e) => { setParam({ ...param, "IDCompany": e }) }} />
                </div>
                <div className="col-md-4">
                    <SelectPayrollFactor idCompany={param.IDCompany} idSelector={param.IDPayrollFactor} onChange={(e) => { setParam({ ...param, IDPayrollFactor: e }) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={param.IDAccount} label="Funcionario" onChange={(e) => { setParam({ ...param, "IDAccount": e.IDAccount }) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-search-line" eventClick={getPayrollDeductionsForCreditQuota} >Buscar</BasicButton>
                </div>


                <div className="col-md-12">
                    <ComponentCreditosDisponiblesDescuentoNominaTercero idAccount={param.IDAccount} month={param.Month} year={param.Year} ref={credits} onChange={(e) => { setMovement(e) }} eventModal={() => {
                        setParam({ ...param, Moves: movement });
                        credits.current?.closeModal();
                    }} />
                </div>

                {employee.IDEmployee &&
                    <>
                        <hr className="mt-3" />
                        <div className="col-md-4">
                            <InputMoney _label="Valor Descuento" _value={employee.Value} onChange={() => { }} readonly />
                        </div>

                        <div className="col-md-4">
                            <label>Empleado</label>
                            <input type="text" className="form-control" readOnly value={employee.Description} />
                        </div>
                        <div className="col-md-4">
                            <SelectTypeProcees label="Tipo de Proceso" idSelector={param.ProcessType} onChange={(e) => setParam({ ...param, "ProcessType": e })} />
                        </div>
                        <div className="col-md-4">
                            <CustomProcessTypeSeleect processType={param.ProcessType} idSelector={param.CustomProcessType} onChange={(e) => setParam({ ...param, "CustomProcessType": e })} />
                        </div>
                        <div className="col-md-4">
                            <InputDate label="Fecha de Registro Contable" name="accountantDate" value={param.AccountantDate} setDate={(e) => { setParam({ ...param, "AccountantDate": e }) }} />
                        </div>
                        <div className="col-md-4">
                            <BudgetAccountantOperationSelect label="Proceso Contable Presupuestal" idSelector={param.idBudgetAccountantOperation} onChange={(e) => { setParam({ ...param, "idBudgetAccountantOperation": e }) }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea name="description" className="form-control" value={param.Description} onChange={(e) => { setParam({ ...param, "Description": e.target.value }) }}></textarea>
                        </div>
                        <div className="col-md-12">
                            <label>Lista de Movimientos a Aplicar</label>
                            <ul className="list-group d-flex flex-wrap flex-row" >
                                {param.Moves.length > 0 ? (

                                    param.Moves.map((item, index) => {
                                        return (
                                            <li
                                                className="list-group-item m-1 d-flex flex-column justify-content-between"
                                                style={{ flex: '0 0 calc(25% - 1rem)' }}
                                                key={index}
                                            >
                                                <div>
                                                    <strong>Crédito:</strong> <span>#{item.LoanNumber}</span><br />
                                                </div>
                                                <div className="d-flex align-items-center">
                                                    <strong>Valor del Movimiento:</strong>{" "}
                                                    <span dangerouslySetInnerHTML={{ __html: _single.formatFieldMask(item.Value, 2) }} />
                                                </div>
                                            </li>
                                        );
                                    })
                                )
                                    :
                                    <Alert children={`Sin Movimientos`} clase="info" />
                                }
                            </ul>
                        </div>
                        <div className="col-md-12 mt-2">
                            <BasicButton disable={document.length > 0} icon="ri-pie-chart-2-line" eventClick={grabarCompensacion}>Aplicar Distribucion</BasicButton>
                        </div>
                    </>
                }

                <div className="col-md-12">
                    <Modal modal={modalDocumento.modal} updateModal={modalDocumento.setModal}>
                        <DocumentViewer list={document} />
                    </Modal>
                </div>
            </div>

        </BasicPage>
    )
}